import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
  Box,
  Divider,
  Stack,
  Grid,
  Typography,
  Input,
  TextField,
  Autocomplete,
  Button,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  RadioGroup,
  Radio,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";


import CustomLabel from "../../../CustomLable";

import "react-transliterate/dist/index.css";

import PrintIcon from "@mui/icons-material/Print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";

import * as XLSX from "xlsx";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function StockReport() {
  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [isMember, setMember] = useState<any>([]);
  const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null);
  const [isHovered, setIsHovered] = useState(false);

  const [selectedFormat, setSelectedFormat] = useState<any>("pdf");

  const [isItemId, setItemId] = useState();

  const [open, setOpen] = useState(false);
  const [Row, setRow] = useState<any>(null);

  const { t } = useTranslation();

  const [Program, setProgram] = useState<any>([
    { value: "-1", label: t("text.SelectItem") },
  ]);

  const [isPrint, setPrint] = useState([]);

  const closeStatus = () => {
    setOpen(false);
  };

  useEffect(() => {
    getProgram();
  }, []);

  const getProgram = () => {
    const collectData = {
      itemMasterId: -1,
    }
    api.post(`ItemMaster/GetItemMaster`, collectData).then((res: any) => {
      const arr: any = [];

      for (let index = 0; index < res?.data?.data?.length; index++) {
        arr.push({
          value: res?.data?.data[index]["itemMasterId"],
          label: res?.data?.data[index]["itemName"],
        });
      }
      setProgram(arr);
    });
  };



  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat((event.target as HTMLInputElement).value);
  };

  const downloadTabularExcel = () => {
    if (!isPrint || isPrint.length === 0) {
      console.error("No data to export to Tabular HTML.");
      return;
    }
  
    // Prepare headers and rows for HTML table
    const headers = [
      "Item Name",
      "Unit Name",
      "Rate",
      "Voucher Type",
      "In Quantity",
      "Out Quantity",
    ];
  
    const rows = isPrint.map((item: any) => [
      item?.titleName || "",
      item?.unitName || "",
      item?.rate || "",
      item?.voucherType || "",
      item?.inQty || "_ _",
      item?.outQty || "_ _",
    ]);
  
    // Create HTML table with enhanced styles and icons
    let html = `
      <html>
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Stock Report</title>
          <!-- Include FontAwesome icons for visuals -->
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">
          <style>
            body {
              font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
              background-color: #f0f4f7;
              color: #333;
              margin: 0;
              padding: 0;
            }
            .report-container {
              width: 95%;
              max-width: 1200px;
              margin: 40px auto;
              background-color: #ffffff;
              border-radius: 10px;
              box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
              padding: 40px;
              padding-bottom: 60px;
            }
            .header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 30px;
            }
            .logo {
              max-width: 150px;
              height: auto;
            }
            .header-title {
              text-align: center;
              color: #1a73e8;
              font-size: 28px;
              font-weight: 600;
              flex-grow: 1;
            }
            .generated-date {
              color: #888;
              font-size: 14px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }
            th {
              background-color: #1a73e8;
              color: white;
              font-weight: bold;
              padding: 16px;
              text-align: left;
              border: 1px solid #ddd;
              text-transform: uppercase;
            }
            td {
              padding: 12px;
              text-align: left;
              border: 1px solid #ddd;
              font-size: 16px;
              color: #333;
            }
            tr:nth-child(even) {
              background-color: #f7f7f7;
            }
            tr:hover {
              background-color: #f1f1f1;
            }
            .footer {
              text-align: center;
              font-size: 14px;
              color: #888;
              margin-top: 40px;
            }
            .footer a {
              color: #1a73e8;
              text-decoration: none;
            }
            .footer a:hover {
              text-decoration: underline;
            }
            .page-footer {
              font-size: 12px;
              color: #aaa;
              margin-top: 40px;
            }
          </style>
        </head>
        <body>
          <div class="report-container">
            <!-- Header Section: Logo, Title, Date -->
            <div class="header">
              <img class="logo" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQb4HkK_VJ8hgOaOz_hcsBXPslnFWgCrfxFg&s" alt="Company Logo">
              <div class="header-title">Stock Report</div>
              <div class="generated-date">
                Generated on: ${new Date().toLocaleDateString("en-GB")}
              </div>
            </div>
            
            <!-- Table Section -->
            <table>
              <thead>
                <tr>
                  ${headers.map((header) => `<th>${header}</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                ${rows
                  .map(
                    (row: any) =>
                      `<tr>${row
                        .map(
                          (cell: any) =>
                            `<td>${cell}</td>`
                        )
                        .join("")}</tr>`
                  )
                  .join("")}
              </tbody>
            </table>
            
            <div class="footer">
              <p>Company Name | <a href="mailto:support@company.com">Contact Us</a></p>
            </div>
          </div>
        </body>
      </html>
    `;
  
    // Create a Blob from the HTML string and trigger the download
    const blob = new Blob([html], { type: "text/html" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Stock_report_data_tabular.html";
    link.click();
  };
  
  

  const downloadExcel = () => {
    if (!isPrint || isPrint.length === 0) {
      console.error("No data to export to Excel.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(isPrint);

    const headers = Object.keys(isPrint[0]);

    headers.forEach((header, index) => {
      const cellAddress = `${String.fromCharCode(65 + index)}1`;
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "vehicles");

    XLSX.writeFile(wb, "Vehicle_data.xlsx");
  };

  // Function to download PDF

  // Handle Download Button Click
  const handleDownload = () => {
    if (selectedFormat === "excel") {
      downloadExcel();
    } else if (selectedFormat === "pdf") {
      downloadPDF();
    } else if (selectedFormat === "tabular") {
      downloadTabularExcel();
    }
  };

  const downloadPDF = () => {
    if (!isPrint || isPrint.length === 0) {
      console.error("No data to export to PDF.");
      return;
    }

    // Initialize jsPDF with 'landscape' orientation
    const doc = new jsPDF("landscape"); // This sets the page orientation to landscape
    let yPosition = 10;
    const headerFontSize = 14;
    const bodyFontSize = 12;

    doc.setFontSize(headerFontSize);
    doc.setFont("helvetica", "bold");
    doc.text("Vehicle Data", 14, yPosition);
    yPosition += 10;

    const headers = ["Item Name", "Rate", "Voucher Type", "In Quantity", "Out Quantity"];

    const columnWidths = [50, 50, 70, 50, 50];

    const headerHeight = 8;
    const headerY = yPosition;
    doc.setFillColor(200, 220, 255);
    doc.rect(
      14,
      headerY,
      columnWidths.reduce((a, b) => a + b, 0),
      headerHeight,
      "F"
    );

    doc.setFont("helvetica", "bold");
    headers.forEach((header, index) => {
      doc.text(
        header,
        14 + columnWidths.slice(0, index).reduce((a, b) => a + b, 0),
        yPosition + headerHeight - 2
      );
    });

    const headerBottomMargin = 6;
    yPosition += headerHeight + headerBottomMargin;

    // Add table rows
    doc.setFontSize(bodyFontSize);
    doc.setFont("helvetica", "normal");

    isPrint.forEach((item: any, rowIndex) => {
      const row = [
        item?.titleName || "",
        
        item?.rate || "", // Vehicle No
        item?.voucherType || "", // Driver
        item?.inQty || "", // Mobile No
        item?.outQty || "",
      ];

      row.forEach((cell, colIndex) => {
        const xOffset =
          14 + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
        if (cell) {
          doc.text(cell.toString(), xOffset, yPosition);
        }
      });
      yPosition += 10;

      if (yPosition > 180) {
        // Adjust this to your content size for landscape
        doc.addPage();
        yPosition = 10; // Reset position on new page
      }
    });

    // Save the generated PDF with a filename
    doc.save("Stock_Report.pdf");
  };

  const fetchZonesData = async () => {
    try {
      const collectData = {
        voucherId: -1,
        stockBinId: 5,
        itemId: isItemId || -1,
      };

      const response = await api.post(
        `StockLedger/GetStockLedgerReportDetails`,
        collectData
      );


      const data = response.data.data;

      const Print = data.map((item: any, index: any) => ({
        ...item,
      }));
      setPrint(Print);
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.entryNo,
      }));
      setZones(zonesWithIds);
      //setIsLoading(false);
      setIsVisible(true);
      setMember(data);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.5,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "titleName",
            headerName: t("text.ItemName"),
            flex: 1,
            // renderCell: (params) => (
            //   <span
            //     onClick={() => {
            //       setOpen(true);
            //       setRow(params?.row);
            //     }}
            //     style={{
            //       color: "blue",
            //       textDecoration: "underline",
            //       cursor: "pointer",
            //     }}
            //   >
            //     {params.value}
            //   </span>
            // ),
          },

          {
            field: "unitName",
            headerName: t("text.UnitName"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "rate",
            headerName: t("text.Rate"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "voucherType",
            headerName: t("text.voucherType"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },


          {
            field: "inQty",
            headerName: t("text.InQuantity"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "outQty",
            headerName: t("text.OutQuantity"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },



          // {
          //   field: "openning",
          //   headerName: t("text.Opening"),
          //   flex: 1,
          //   // headerClassName: "MuiDataGrid-colCell",
          // },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  const formik = useFormik({
    initialValues: {
      MemberId: 0,
      MemberName: "",
      memberGroup: "",
      Department: "",
      FromCourse: "",
    },

    onSubmit: async (values) => { },
  });

  const handleReturn = (event: any) => {
    if (event.target.checked) {
      formik.setFieldValue("status", "Y");
    } else {
      formik.setFieldValue("status", "N");
    }
  };

  const handleAsOn = (event: any) => {
    if (event.target.checked) {
      formik.setFieldValue("canRequest", "Y");
    } else {
      formik.setFieldValue("canRequest", "N");
    }
  };

  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "lightgreen",
          border: ".5px solid #2B4593",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            // backgroundColor:"lightseagreen"
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Grid item xs={12} container spacing={1}>
            <Grid item lg={10} md={10} xs={12}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ padding: "20px" }}
                align="left"
              >
                {t("text.StockReport")}
              </Typography>
            </Grid>

            <Grid item lg={2} md={2} xs={12} marginTop={2}></Grid>
          </Grid>

          <Divider />

          <Box height={10} />
          <form onSubmit={formik.handleSubmit}>
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={[{ value: -1, label: "Select All" }].concat(Program)}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    //console.log(newValue?.value);

                    setItemId(newValue?.value);
                  }}
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      label={
                        <CustomLabel
                          text={t("text.SelectItem")}
                          required={false}
                        />
                      }
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={2} lg={2}>
                <Button
                  onClick={fetchZonesData}
                  variant="contained"
                  endIcon={<SearchIcon />}

                  style={{ backgroundColor: `var(--header-background)` }}
                >
                  search
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                sm={1}
                lg={1}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleDownload}
              >
                <PrintIcon
                  style={{ color: isHovered ? "black" : "blue" }}
                  fontSize="large"
                />
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    value={selectedFormat}
                    onChange={handleFormatChange}
                  >
                    <FormControlLabel
                      value="pdf"
                      control={<Radio />}
                      label="PDF"
                    />
                    <FormControlLabel
                      value="excel"
                      control={<Radio />}
                      label="Excel"
                    />
                    <FormControlLabel
                      value="tabular"
                      control={<Radio />}
                      label="Tabular Excel"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>


              {isVisible && (
                <>
                  <Grid item sm={12} lg={12} xs={12} id="data-grid">
                    <DataGrid
                      rows={zones}
                      columns={adjustedColumns}
                      rowSpacingType="border"
                      autoHeight
                      // checkboxSelection
                      pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                        value: size,
                        label: `${size}`,
                      }))}
                      // onRowSelectionModelChange={handleRowSelection}
                      // rowSelectionModel={selectedRows} // Default selected rows
                      initialState={{
                        pagination: { paginationModel: { pageSize: 5 } },
                      }}
                      sx={{
                        border: 0,
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: `var(--grid-headerBackground)`,
                          color: `var(--grid-headerColor)`,
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                          color: "white",
                        },
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>

            <Grid item xs={12} container spacing={2}>
              <Grid item sm={12} lg={12} xs={12}>
                <Dialog
                  open={open}
                  onClose={closeStatus}
                  fullWidth
                  sx={{
                    "& .MuiDialogContent-root": {
                      padding: "20px",
                      height: "350px",
                    },
                  }}
                >
                  <DialogTitle
                    style={{
                      padding: "10px",
                      backgroundColor: `var(--grid-headerBackground)`,
                      color: `var(--grid-headerColor)`,
                    }}
                  >
                    Stock Summary Details
                  </DialogTitle>
                  <DialogContent>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={2}
                      sx={{ marginTop: "2%" }}
                    >
                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          align="left"
                          marginTop="2%"
                        >
                          Title Name:{""}{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {Row?.titleName}
                          </span>
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          align="left"
                          marginTop="2%"
                        >
                          Rate(s):{""}{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {Row?.rate}
                          </span>
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          align="left"
                          marginTop="2%"
                        >
                          In Quantity:{""}{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {Row?.inQty}
                          </span>
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          align="left"
                          marginTop="2%"
                        >
                          Out Quantity:{""}{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {Row?.outQty}
                          </span>
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          align="left"
                          marginTop="2%"
                        >
                          total In Ammount:{""}{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {Row?.totalInAmount}
                          </span>
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={6} lg={6}>
                        <Typography
                          gutterBottom
                          variant="h6"
                          component="div"
                          align="left"
                          marginTop="2%"
                        >
                          total Out Ammount:{""}{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {Row?.totalOutAmount}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </DialogContent>
                </Dialog>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
}
